import templateUrl from './edit-icd-corporation-payout-policy-modal.component.html'

export const EditIcdCorporationPayoutPolicyModalComponent = {
    controller: EditIcdCorporationPayoutPolicyModalController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
};

function EditIcdCorporationPayoutPolicyModalController() {
    const vm = this;

    vm.onCancel = onCancel;
    vm.onDeletePayoutPolicy = onDeletePayoutPolicy;
    vm.onDeleteRepPayoutPolicy = onDeleteRepPayoutPolicy;
    vm.onSave = onSave;
    vm.$onInit = onInit;

    function onInit() {
        vm.icdPayoutPolicy = vm.resolve.icdCorporationPayoutPolicy;
        vm.icdCorporations = vm.resolve.icdCorporations;
        vm.save = vm.resolve.save;
    }

    function onCancel() {
        vm.dismiss({ $value: "cancel" })
    }

    function onSave() {
        vm.save(vm.icdPayoutPolicy)
            .then(function () {
                vm.close({ $value: vm.icdPayoutPolicy });
            });
    }

    function onDeletePayoutPolicy(policy) {
        vm.icdPayoutPolicy.PayoutPolicies = vm.icdPayoutPolicy.PayoutPolicies.filter(function (p) {
            return p !== policy;
        });
    }

    function onDeleteRepPayoutPolicy(policy) {
        vm.icdPayoutPolicy.RepPayoutPolicies = vm.icdPayoutPolicy.RepPayoutPolicies.filter(function (p) {
            return p !== policy;
        });
    }
}
